import React from 'react';

const Section4Lifestyle = ({ formData, handleChange }) => (
    <div className="fade-in">
        <h4 className="mb-3">4. Lifestyle & Personal Preferences</h4>
        <div className="row">
            <div className="col-md-4 mb-3">
                <label className="form-label">Diet</label>
                <select name="diet" value={formData.diet} onChange={handleChange} className="form-select">
                    <option>Vegetarian</option>
                    <option>Eggetarian</option>
                    <option>Non-Vegetarian</option>
                </select>
            </div>
            <div className="col-md-4 mb-3">
                <label className="form-label">Drinking Habits</label>
                <select name="drinking" value={formData.drinking} onChange={handleChange} className="form-select">
                    <option>No</option>
                    <option>Occasionally</option>
                    <option>Yes</option>
                </select>
            </div>
            <div className="col-md-4 mb-3">
                <label className="form-label">Smoking Habits</label>
                <select name="smoking" value={formData.smoking} onChange={handleChange} className="form-select">
                    <option>No</option>
                    <option>Occasionally</option>
                    <option>Yes</option>
                </select>
            </div>
        </div>
        <div className="mb-3">
            <label className="form-label">Hobbies & Interests</label>
            <input type="text" name="hobbies" value={formData.hobbies} onChange={handleChange} className="form-control" placeholder="e.g., Reading, Traveling, Cooking" />
        </div>
        <div className="mb-3">
            <label className="form-label">Languages Known</label>
            <input type="text" name="languages" value={formData.languages} onChange={handleChange} className="form-control" placeholder="e.g., Marathi, Hindi, English" />
        </div>
    </div>
);

export default Section4Lifestyle;